import { useState,useRef,useEffect } from 'react'
import useCurrentTeacher from '../../../../hooks/useCurrentTeacher'
const Portfolio = () => {
  const { teacher, fetchCurrentTeacher } = useCurrentTeacher()
  const [selectedFiles, setSelectedFiles] = useState([])
  const [editingIndex, setEditingIndex] = useState(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null) 
   // Inside your component
   const dropdownRef = useRef(null)
   useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpenDropdownIndex(null)
    }
  }

  document.addEventListener('mousedown', handleClickOutside)
  return () => {
    document.removeEventListener('mousedown', handleClickOutside)
  }
}, [dropdownRef])

  if (!teacher) return null

  const handleAdd = async () => {
    if (selectedFiles.length === 0) {
      setError('Please select at least one file.')
      return
    }
    setLoading(true)
    try {
      const formData = new FormData()
      formData.append('portfolio', selectedFiles[0])

      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/teacher/${teacher.id}/portfolio/add/`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: formData,
      })

      if (res.ok) {
        alert('Portfolio added successfully!')
        fetchCurrentTeacher()
        setSelectedFiles([])
        setError('')
      } else {
        const data = await res.json()
        alert(data.msg || 'Failed to add portfolio')
      }
    } catch (err) {
      console.error(err)
      alert('Error adding portfolio')
    } finally {
      setLoading(false)
    }
  }

  const handleEdit = async (index) => {
    if (!selectedFiles[index]) {
      setError('Please select a file to update.')
      return
    }

    const portfolioId = teacher.portfolios[index].id
    setLoading(true)
    try {
      const formData = new FormData()
      formData.append('portfolio', selectedFiles[index])

      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/teacher/portfolio/${portfolioId}/edit/`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: formData,
      })

      if (res.ok) {
        alert('Portfolio updated successfully!')
        fetchCurrentTeacher()
        setSelectedFiles([])
        setEditingIndex(null)
        setError('')
      } else {
        const data = await res.json()
        alert(data.msg || 'Failed to update portfolio')
      }
    } catch (err) {
      console.error(err)
      alert('Error updating portfolio')
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async (index) => {
  if (!window.confirm('Are you sure you want to delete this portfolio?')) return

  const portfolioId = teacher.portfolios[index].id
  setLoading(true)
  try {
    const res = await fetch(`${process.env.REACT_APP_BASE_URL}/teacher/portfolio/${portfolioId}/delete/`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        "x-api-key": process.env.REACT_APP_X_API_KEY
      },
    })

    if (res.ok) {
      alert('Portfolio deleted successfully!')
      fetchCurrentTeacher()
    } else {
      const data = await res.json()
      alert(data.msg || 'Failed to delete portfolio')
    }
  } catch (err) {
    console.error(err)
    alert('Error deleting portfolio')
  } finally {
    setLoading(false)
  }
}


  return (
  <div className="bg-white rounded-2xl p-2 md:p-6 w-full">
  {/* Header */}
  <div className="flex items-center justify-between mb-6">
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
        <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      </div>
      <div>
        <h2 className="text-lg font-semibold text-gray-900">Your Portfolio</h2>
        <p className="text-sm text-gray-500 mt-0.5">Upload and manage your portfolio documents</p>
      </div>
    </div>

    <div className="flex items-center gap-3">
      <label
        className="flex items-center justify-center w-10 h-10 bg-[#e8f0f7] rounded-lg cursor-pointer hover:bg-[#d0e0f0] transition-colors"
        title="Add New"
      >
        <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
        </svg>
        <input
          type="file"
          accept="application/pdf"
          className="hidden"
          onChange={(e) => {
            setSelectedFiles([e.target.files[0]]);
            setEditingIndex(null);
          }}
        />
      </label>

      {selectedFiles.length > 0 && editingIndex === null && (
        <button
          className="px-4 py-2 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50"
          onClick={handleAdd}
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              Uploading...
            </div>
          ) : (
            "Upload"
          )}
        </button>
      )}
    </div>
  </div>

  {error && (
    <div className="mb-4 p-3 bg-red-50 text-red-600 text-sm rounded-xl">
      {error}
    </div>
  )}

  {teacher.portfolios?.length > 0 && (
    <div className="space-y-6">
      {teacher.portfolios.map((fileObj, index) => (
        <div
          key={fileObj.id}
          className="relative border border-gray-200 rounded-2xl  py-5 px-2 md:px-5 shadow-sm hover:border-gray-300 transition-colors"
        >
          <iframe
            src={fileObj.file}
            title={`Portfolio PDF ${index + 1}`}
            className="w-full h-[600px] rounded-xl border border-gray-100 mt-2"
          />

          {editingIndex === index && selectedFiles[index] ? (
            <button
              className="absolute top-6 right-6 px-4 py-2 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors z-10"
              onClick={() => handleEdit(index)}
              disabled={loading}
            >
              {loading ? (
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Saving...
                </div>
              ) : (
                "Save Changes"
              )}
            </button>
          ) : (
            <div className="absolute top-1 right-1 flex gap-2 z-10">
              <button
                className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
                onClick={() =>
                  setOpenDropdownIndex(openDropdownIndex === index ? null : index)
                }
              >
                <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                </svg>
              </button>

              {openDropdownIndex === index && (
                <div
                  ref={dropdownRef}
                  className="absolute top-10 right-0 bg-white rounded-xl shadow-lg border border-gray-200 py-1 min-w-[140px] z-50"
                >
                  <label className="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 cursor-pointer hover:bg-gray-50 transition-colors rounded-lg">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                    Edit
                    <input
                      type="file"
                      accept="application/pdf"
                      className="hidden"
                      onChange={(e) => {
                        setSelectedFiles((prev) => {
                          const newFiles = [...prev];
                          newFiles[index] = e.target.files[0];
                          return newFiles;
                        });
                        setEditingIndex(index);
                      }}
                    />
                  </label>

                  <div
                    className="flex items-center gap-3 px-4 py-2.5 text-sm text-red-500 cursor-pointer hover:bg-red-50 transition-colors rounded-lg"
                    onClick={() => handleDelete(index)}
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                    Delete
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  )}
</div>
  )
}

export default Portfolio
